// extracted by mini-css-extract-plugin
export default {"notifications":"styles_notifications__pMzWZ","notifications__border":"styles_notifications__border__ZY48R"};